import styled from "styled-components";
import { tablet } from "storybook/utils/breakpoints";

const Container = styled.div`
  width: 100%;
  position: relative;
`;

const TextContainer = styled.div`
  inset: 0;
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;

  span {
    width: 100%;
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    color: rgba(0, 0, 0, 0.3);
  }

  @media (min-width: ${tablet}px) {
    span {
      font-size: 20px;
    }
  }
`;

const HighContainer = styled.div`
  position: absolute;
  bottom: 15px;
  left: 0;
  display: flex;
  width: 45%;

  @media (min-width: ${tablet}px) {
    bottom: 25px;
  }
`;

const LowContainer = styled.div`
  display: flex;
  position: absolute;
  top: 12px;
  right: 0;
  width: 45%;

  @media (min-width: ${tablet}px) {
    top: 21px;
  }
`;

export function RiskEvaluationIcon() {
  return (
    <Container>
      <TextContainer>
        <HighContainer>
          <span>High</span>
        </HighContainer>
        <LowContainer>
          <span>Low</span>
        </LowContainer>
      </TextContainer>
      <svg fill="none" viewBox="0 0 292 150" xmlns="http://www.w3.org/2000/svg">
        <rect
          x="163.924"
          y="67.8545"
          width="121.176"
          height="58.0279"
          rx="6.82681"
          fill="#D1D8FF"
          fillOpacity="0.4"
        />
        <rect
          x="5.20117"
          y="23.4805"
          width="121.176"
          height="58.0279"
          rx="6.82681"
          fill="#D1D8FF"
          fillOpacity="0.4"
        />
        <path
          d="M52.9324 53.6975V84.0118H80.4785V53.7063L95.3994 53.7109L66.0757 24.3877L37.1011 53.6928L52.9324 53.6975Z"
          stroke="#AF021C"
          strokeWidth="4.50925"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M42.0364 99.3283C25.9684 90.6904 15.0446 73.7214 15.0446 54.2008C15.0446 25.9236 37.9682 3 66.2459 3C94.5231 3 117.447 25.9236 117.447 54.2008C117.447 73.9266 106.292 91.0464 89.9472 99.5977"
          stroke="#AF021C"
          strokeWidth="4.50925"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          x="0.934406"
          y="20.9207"
          width="129.709"
          height="66.5614"
          rx="5.97346"
          stroke="#7A7B95"
          strokeWidth="1.7067"
          strokeDasharray="16 16"
        />
        <path
          d="M249.575 51.0575C265.643 59.6953 276.567 76.6643 276.567 96.185C276.567 124.462 253.643 147.386 225.365 147.386C197.088 147.386 174.165 124.462 174.165 96.185C174.165 76.4591 185.319 59.3394 201.664 50.7881"
          stroke="#59B14A"
          strokeWidth="5.12011"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M238.819 96.6863V66.372H211.272V96.6775L196.352 96.6729L225.675 125.996L254.65 96.691L238.819 96.6863Z"
          stroke="#59B14A"
          strokeWidth="5.12011"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          x="160.511"
          y="63.5887"
          width="129.709"
          height="66.5614"
          rx="5.97346"
          stroke="#7A7B95"
          strokeWidth="1.7067"
          strokeDasharray="16 16"
        />
      </svg>
    </Container>
  );
}
